{
    const forms = document.querySelectorAll('.js-filter-form');
    const select = document.querySelector('.js-filter-select');
    const selectToggle = select && select.querySelector('.blog-select__toggle');
    const selectOptions = select && select.querySelectorAll('.blog-select__option');
    const dropdown = document.querySelector('.js-filter-dropdown');
    const tagsFilter = document.querySelector('.js-filter-tag');
    const tags = tagsFilter && tagsFilter.querySelectorAll('.mb-checkbox-input');

    // 1. filter: category
    if (select && forms) {
        // init first form
        forms[0].classList.add('is-active');

        selectToggle.addEventListener('click', function () {
            select.classList.toggle('is-opened');
            this.removeEventListener('click', this);
        });

        // filter post by categories
        selectOptions.forEach(option => {
            option.addEventListener('click', function () {
                const optionName = this.getAttribute('data-name');
                const optionValue = this.getAttribute('data-value');

                selectToggle.textContent = optionName;
                selectToggle.setAttribute('data-value', optionValue);

                forms.forEach(form => {
                    form.reset();
                    (form.getAttribute('data-category') === optionValue)
                        ? form.classList.add('is-active')
                        : form.classList.remove('is-active');
                });

                filterEntries(`/wp-json/wp/v2/blog?blog_category=${optionValue}&lang=${m.about.language}`)

                // reset tag filter
                tags.forEach(tag => { tag.checked = false });

                select.classList.remove('is-opened');
                this.removeEventListener('click', this);
            });
        });

        // Close the select in the event of outside click
        document.addEventListener('click', function (e) {
            if (!e.target.matches('.blog-select__toggle')) {
                if (select.classList.contains('is-opened')) {
                    select.classList.remove('is-opened');
                }
            }

            this.removeEventListener('click', this);
        });
    }


    // 2. filter: subcategory
    if (dropdown && forms) {
        const dropdownToggle = dropdown.querySelector('.blog-dropdown__toggle');
        const dropdownContent = dropdown.querySelector('.blog-dropdown__content');

        dropdownToggle.addEventListener('click', function () {
            dropdown.classList.toggle('is-opened');
            this.removeEventListener('click', this);
        });

        dropdownContent.addEventListener('click', function (e) {
            e.stopPropagation();
            this.removeEventListener('click', this);
        });

        // Close the dropdown in the event of outside click
        document.addEventListener('click', function (e) {
            if (!e.target.matches('.blog-dropdown__toggle')) {
                if (dropdown.classList.contains('is-opened')) {
                    dropdown.classList.remove('is-opened');
                }
            }

            this.removeEventListener('click', this);
        });

        // filter posts by subcategories
        forms.forEach(form => {
            form.addEventListener('submit', function (e) {
                const categories = [];
                const checkboxes = form.querySelectorAll('.mb-checkbox-input');
                const parentCategoryId = selectToggle.getAttribute('data-value');

                // check chosen checkboxes
                checkboxes.forEach(checkbox => {
                    if (checkbox.checked) categories.push(checkbox.value);
                });

                // build filter categories query
                const query = categories.length > 0 ? categories.join() : parentCategoryId;

                filterEntries(`/wp-json/wp/v2/blog?blog_category=${query}&lang=${m.about.language}`)

                // reset tag filter
                tags.forEach(tag => { tag.checked = false });

                dropdown.classList.remove('is-opened');
                e.preventDefault();
            });
        });
    }


    // 3. filter: tags
    if (tagsFilter && tags && forms) {
        let tagsId = [];

        tags.forEach(tag => {
           tag.addEventListener('change', function () {
               tagsId = this.checked ? tagsId.concat(this.value) : tagsId.filter(item => item !== this.value);

               filterEntries(`/wp-json/wp/v2/blog?blog_tag=${tagsId}&lang=${m.about.language}`)

               // reset category filter
               selectOptions.forEach((option, index) => {
                   if (!index) {
                       const name = option.getAttribute('data-name');
                       const value = option.getAttribute('data-value');

                       selectToggle.textContent = name;
                       selectToggle.setAttribute('data-value', value);
                   }
               });

               // reset subcategory filter
               forms.forEach((form, index) => {
                   form.reset();
                   (!index) ? form.classList.add('is-active') : form.classList.remove('is-active');
               });

               this.removeEventListener('change', this);
           });
        });
    }


    // 4. filter: archive
    const collapses = document.querySelectorAll('.blog-collapse');

    collapses.forEach(collapse => {
        const toggle = collapse.querySelector('.blog-collapse__toggle');
        const content = collapse.querySelector('.blog-collapse__content');

       toggle.addEventListener('click', function() {
           toggle.classList.toggle('is-opened');
           content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + 'px';

           this.removeEventListener('click', this);
        });
    });


    /**
     * Get entries HTML DOM nodes
     * @param  {Object} data. The entries data
     * @param  {String} selector. The entries parent's node selector
     * @return {Node} The template HTML
     */
    function getEntries(data, selector) {
        if (!data) return;

        let entries = '';
        const container = document.querySelector(selector);

        // Build entries list
        data.forEach(item => {
            const category = () => {
                let output = '';

                item.categories_parent.forEach(category => {
                    output += `<span class="blog-tag active">${category}</span>`;
                });

                return output;
            };
            const tags = () => {
                let output = '';

                item.tags.forEach(tag => {
                    output += `<span class="blog-tag">${tag}</span> `;
                });

                return output;
            };

            const template =
                `<article class="blog-entry">
                    <div class="blog-entry-head">
                        <div class="blog-entry-head__thumb">
                            <a href="${item.link}">
                                <img class="blog-entry-head__img" src="${item.featured_img}" alt="">
                            </a>
                        </div>
                        <h4 class="blog-entry-head__title">${item.title.rendered}</h4>
                    </div>
                    <div class="blog-entry-body">
                        <h4 class="blog-entry-title"><a href="${item.link}">${item.title.rendered}</a></h4>
                        <div class="blog-entry-date">${item.formatted_date}</div>
                        <div class="blog-entry-tags">${category()} ${tags()}</div>
                        <div class="blog-entry-content"><a href="${item.link}">${item.custom_excerpt}</a></div>
                    </div>
                </article>`
            ;

            entries += template;
        });

        container.innerHTML = entries;
    }

    /**
     * Filter entries HTML DOM nodes
     * @param  {URL} apiURI. The filtered entries url
     */
    function filterEntries(apiURI) {
        fetch(apiURI)
            .then(res => res.json())
            .then(data => getEntries(data, '.js-blog-entries'))
            .catch(err => console.warn(err));
    }
}
